import {
  Platform,
  PlatformCorporateSettings,
  PlatformColorsUpdateForm,
  PlatformCreateForm,
  PlatformCreateResponse,
  PlatformsGetResponse,
  PlatformPublicLandingForm,
  PlatformSocialLinksUpdateForm,
  PlatformUpdateForm,
  PlatformImagesUpdateForm,
  PlatformBrandUpdateForm,
} from 'src/types';
import axios, { ENDPOINTS } from 'src/utils/axios';

export const createPlatform = async (data: PlatformCreateForm) => {
  const response = await axios.post<PlatformCreateResponse>(ENDPOINTS.app.platforms, data);

  return response.data;
};

export const getPlatforms = async () => {
  const response = await axios.get<PlatformsGetResponse>(ENDPOINTS.app.platforms);

  return response.data;
};

export const getSinglePlatform = async (platformId: Platform['id']) => {
  const response = await axios.get<Platform>(`${ENDPOINTS.app.platforms}/${platformId}`);

  return response.data;
};

export const updatePlatform = async (platformId: Platform['id'], data: PlatformUpdateForm) => {
  const response = await axios.put<Platform>(`${ENDPOINTS.app.platforms}/${platformId}`, data);

  return response.data;
};

export const deletePlatform = async (platformId: Platform['id']) => {
  const response = await axios.delete<undefined>(`${ENDPOINTS.app.platforms}/${platformId}`);

  return response.data;
};

// Colors

export const updatePlatformColors = async (
  platformId: Platform['id'],
  data: PlatformColorsUpdateForm
) => {
  const response = await axios.put<Platform>(
    `${ENDPOINTS.app.platforms}/${platformId}/colors`,
    data
  );

  return response.data;
};

export const updatePlatformImages = async (
  platformId: Platform['id'],
  data: PlatformImagesUpdateForm
) => {
  const response = await axios.put<Platform>(
    `${ENDPOINTS.app.platforms}/${platformId}/images`,
    data
  );

  return response.data;
};

export const updatePlatformBrand = async (
  platformId: Platform['id'],
  data: PlatformBrandUpdateForm
) => {
  const response = await axios.put<Platform>(
    `${ENDPOINTS.app.platforms}/${platformId}/brand`,
    data
  );

  return response.data;
};

export const updatePlatformPublicLanding = async (
  platformId: Platform['id'],
  data: PlatformPublicLandingForm
) => {
  const response = await axios.put<Platform>(
    `${ENDPOINTS.app.platforms}/${platformId}/public-landing`,
    data
  );

  return response.data;
};

export const updatePlatformSocialLinks = async (
  platformId: Platform['id'],
  data: PlatformSocialLinksUpdateForm
) => {
  const response = await axios.put<Platform>(
    `${ENDPOINTS.app.platforms}/${platformId}/social-links`,
    data
  );

  return response.data;
};

export const updateCorporateSettings = async (data: PlatformCorporateSettings) => {
  const response = await axios.patch<PlatformCorporateSettings>(
    ENDPOINTS.app.corporateSettings,
    data
  );

  return response.data;
};
